import { DocsCtaLink } from "@/components/marketing/DocsCtaLink"
import { Section } from "@/components/marketing/elements/section"
import { Stat } from "@/components/marketing/sections/stats-three-column-with-description"
import {
  BRAND_STORY_HEADLINE,
  BRAND_STORY_PILLARS,
  BRAND_STORY_SUMMARY,
} from "@/content/marketing/site-content"

export function MarketingWhySection({
  heading = BRAND_STORY_HEADLINE,
}: {
  heading?: string
}) {
  return (
    <Section
      id="why"
      eyebrow="Philosophy"
      headline={heading}
      subheadline={<p>{BRAND_STORY_SUMMARY}</p>}
      cta={<DocsCtaLink />}
    >
      <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
        {BRAND_STORY_PILLARS.map((pillar) => (
          <Stat key={pillar.title} stat={pillar.title} text={pillar.body} />
        ))}
      </div>
    </Section>
  )
}
